import type { CSSProperties } from 'react';
import { useState } from 'react';

import { T } from '../styles/tokens';
import { haptic } from '../telegram/sdk';

const wg = ['Установите WireGuard из App Store / Google Play', 'Получите конфиг в боте (.conf или QR)', 'Импортируйте: «+» → Сканировать QR / Файл', 'Включите тумблер — готово'];
const vless = ['Установите v2rayNG / Streisand / Hiddify', 'Скопируйте vless://... ссылку из бота', 'В приложении: «+» → Импорт из буфера', 'Нажмите подключение — готово'];

export default function Instructions() {
  const [proto, setProto] = useState<'wireguard' | 'vless'>('wireguard');
  const steps = proto === 'wireguard' ? wg : vless;

  return (
    <div style={i.wrap}>
      <div style={i.header}>
        <div style={i.headTag}>// как подключиться</div>
        <div style={i.headTitle}>Инструкция</div>
      </div>

      <div style={i.tabs}>
        {(['wireguard', 'vless'] as const).map((id) => (
          <button
            key={id}
            style={{ ...i.tab, ...(proto === id ? i.tabActive : {}) }}
            onClick={() => {
              haptic('light');
              setProto(id);
            }}
          >
            {id === 'wireguard' ? 'WireGuard' : 'VLESS'}
          </button>
        ))}
      </div>

      <div style={i.card}>
        {steps.map((s, idx) => (
          <div key={idx} style={i.step}>
            <div style={i.num}>{String(idx + 1).padStart(2, '0')}</div>
            <div style={i.text}>{s}</div>
          </div>
        ))}
      </div>

      <div style={i.appsLabel}>// приложения</div>
      <div style={i.apps}>
        {(proto === 'wireguard'
          ? [
              { name: 'WireGuard (iOS)', url: 'https://apps.apple.com/app/wireguard/id1441195209' },
              { name: 'WireGuard (Android)', url: 'https://play.google.com/store/apps/details?id=com.wireguard.android' },
            ]
          : [
              { name: 'Streisand (iOS)', url: 'https://apps.apple.com/app/streisand/id6450534064' },
              { name: 'v2rayNG (Android)', url: 'https://play.google.com/store/apps/details?id=com.v2ray.ang' },
            ]
        ).map((app) => (
          <button
            key={app.name}
            style={i.appLink}
            onClick={() => {
              haptic('light');
              window.Telegram?.WebApp?.openLink(app.url);
            }}
          >
            {app.name} →
          </button>
        ))}
      </div>
    </div>
  );
}

const i: Record<string, CSSProperties> = {
  wrap: { padding: '20px 16px 24px' },
  header: { marginBottom: 18 },
  headTag: { fontFamily: 'DM Mono, monospace', fontSize: 10, color: T.accent, letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 4 },
  headTitle: { fontFamily: 'Syne, sans-serif', fontWeight: 800, fontSize: 24, letterSpacing: '-0.03em' },
  tabs: { display: 'flex', gap: 0, marginBottom: 16, borderBottom: `1px solid ${T.border}` },
  tab: { flex: 1, background: 'none', border: 'none', borderBottom: '2px solid transparent', color: T.textSec, fontSize: 13, fontWeight: 600, cursor: 'pointer', padding: '11px 0', fontFamily: 'DM Sans, sans-serif' },
  tabActive: { color: T.accent, borderBottomColor: T.accent },
  card: { background: T.surface, border: `1px solid ${T.border}`, borderRadius: 4, padding: '16px 18px', marginBottom: 18 },
  step: { display: 'flex', gap: 14, padding: '10px 0', alignItems: 'flex-start' },
  num: { fontFamily: 'DM Mono, monospace', fontSize: 11, color: T.accent, letterSpacing: '0.04em', width: 22, paddingTop: 2 },
  text: { fontSize: 13, color: T.textSec, lineHeight: 1.6, flex: 1 },
  appsLabel: { fontFamily: 'DM Mono, monospace', fontSize: 10, color: T.textMuted, letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 10 },
  apps: { display: 'flex', flexDirection: 'column', gap: 6 },
  appLink: { background: T.surface, border: `1px solid ${T.border}`, borderRadius: 3, padding: '11px 14px', color: T.accent, fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'DM Sans, sans-serif', textAlign: 'left' },
};
